import axios from 'axios';
import { refreshToken, logout } from './auth';
import { useState } from 'modules/auth/store/state'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(config => {
  const authState = useState()
  const token = authState.access
  config.headers = config.headers || {};
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

api.interceptors.response.use(
  response => response, 
  async error => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; 

      try {
        const newTokens = await refreshToken(); 
        axios.defaults.headers.common['Authorization'] = `Token ${newTokens.access}`;
        originalRequest.headers['Authorization'] = `Token ${newTokens.access}`;
        
        return api(originalRequest); 
      } catch (refreshError) {
        console.error("Errore nel refresh token, eseguo logout:", refreshError);
        logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error); 
  }
);

export default api;
